import React, { useEffect, useState } from 'react'
// import { Usecoursecontext } from './coursecontext/course_context'
import { NavLink, useParams, useNavigate, useLocation, Link } from 'react-router-dom';
import { UseGlobelcourse } from './allcoursecontaxt/ALLCoursecontaxt';
import { Usecartcontaxt } from './cartcontaxt/cart_contaxt';
import Formatprice from './Helper/Formatprice';
import Service from '../Service';
import Styled, { styled } from "styled-components"
import { Modal, Button } from 'react-bootstrap';
import Login from './Login';
import Signin from './Signin';
import { UseGlobellogin } from './Logincontaxt.jsx/Logincontex';
import { FaWhatsapp } from "react-icons/fa6";
import { FaInstagram } from "react-icons/fa";
import { FaLinkedinIn } from "react-icons/fa";
import { FaCopy } from "react-icons/fa6";
import { ClipLoader } from "react-spinners";
import { BASE_URL } from '../Config/Config';
// import Loading from '../Loader/Loading';
import Loader from '../Loader/Loader';
import SubLoading from '../ALL CSS/Loading';
import { Useglobelcontext } from './blogcontext/Blogcontext';
import Course_Reviwe from '../CourseReviwe/Course_Reviwe';
import Startr_course from './Start_course/Startr_course';
function Coursedetail() {
  const { getsinglecourse, singleCourse, loading, singlecourseloading } = UseGlobelcourse();
  const { id } = useParams();
  const location = useLocation();
  console.log("singleCourse", singleCourse)
  const [show, setShow] = useState(false);
  const { hash } = useLocation();
  const [isSignin, setIsSignin] = useState(false);
  const [showOptions, setShowOptions] = useState(false);

  const navigate = useNavigate();
  const handleClose = () => setShow(false);
  const toggleForm = () => setIsSignin((prev) => !prev);

  const { isLoggedIn } = UseGlobellogin();
  //  const {courses} = Usecoursecontext();    
  const { AddTocart } = Usecartcontaxt();
  const [ActiveTab, setActiveTab] = useState('Coursedescription');

  useEffect(() => {
    if (id) {
      getsinglecourse(id);
    }
  }, [id]);

  const [bannerData, setBannerImage] = useState([]);
  const [bannerLoading, setBannerLoading] = useState(true);

  useEffect(() => {
    const fetchBannerImage = async () => {
      try {
        setBannerLoading(true);
        const response = await fetch(`${BASE_URL}/banner/?page=CourseDetail`);
        const result = await response.json();
        setBannerImage(result.data[0]);
      } catch (error) {
        console.error('Error fetching banner:', error);
      } finally {
        setBannerLoading(false);
      }
    };

    fetchBannerImage();
  }, []);

  const handleTabClick = ((tabname) => {
    setActiveTab(tabname);
  })



  useEffect(() => {
    // Set background image from data-bg-src
    const bgSrcElements = document.querySelectorAll('[data-bg-src]');
    bgSrcElements.forEach((element) => {
      const src = element.getAttribute('data-bg-src');
      if (src) {
        element.style.backgroundImage = `url(${src})`;
        element.classList.add('background-image');
        element.removeAttribute('data-bg-src');
      }
    });
    // Set background color from data-bg-color
    const bgColorElements = document.querySelectorAll('[data-bg-color]');
    bgColorElements.forEach((element) => {
      const color = element.getAttribute('data-bg-color');
      if (color) {
        element.style.backgroundColor = color;
        element.removeAttribute('data-bg-color');
      }
    });

    // Set mask image from data-mask-src
    const maskSrcElements = document.querySelectorAll('[data-mask-src]');
    maskSrcElements.forEach((element) => {
      const mask = element.getAttribute('data-mask-src');
      if (mask) {
        element.style.maskImage = `url(${mask})`;
        element.style.WebkitMaskImage = `url(${mask})`;
        element.classList.add('bg-mask');
        element.removeAttribute('data-mask-src');
      }
    });
  }, [id]);

  const handleAddToCartClick = (courseid) => {
    if (isLoggedIn) {
      // If logged in, proceed to add to cart and navigate to the cart page
      AddTocart(courseid);
      navigate('/cartpage');
    } else {
      // If not logged in, show the modal for login/signin
      navigate('/login', { state: { from: location } });
    }
  };

  const handleShareClick = () => {
    setShowOptions(!showOptions);
  };

  const handleCopy = () => {
    navigator.clipboard.writeText(window.location.href);
  };

  useEffect(() => {
    if (hash) {
      const element = document.querySelector(hash);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [hash]);
console.log("singleCourse",singleCourse)
  return (
    <>
      {/* <div className="breadcumb-wrapper " data-bg-src="/assets/img/bg/breadcumb-bg.jpg" data-overlay="title" data-opacity={8} style={{height:"50px"}}>
  <div className="breadcumb-shape" data-bg-src="/assets/img/bg/breadcumb_shape_1_1.png">
  </div>
  <div className="shape-mockup breadcumb-shape2 jump d-lg-block d-none" data-right="30px" data-bottom="30px">
    <img src="/assets/img/bg/breadcumb_shape_1_2.png" alt="shape" />
  </div>
  <div className="/shape-mockup breadcumb-shape3 jump-reverse d-lg-block d-none" data-left="50px" data-bottom="80px">
    <img src="/assets/img/bg/breadcumb_shape_1_3.png" alt="shape" />
  </div>
  <div className="container">
    <div className="breadcumb-content text-center">
      <h1 className="breadcumb-title">Courses Details</h1>
      <ul className="breadcumb-menu">
        <li><a href="/">Home</a></li>
        <li>Courses Details</li>
      </ul>
    </div>
  </div>
</div> */}

      {
        bannerLoading && bannerData && bannerData.image ? (
          <SubLoading />
        ) : (
          <div className="breadcumb-wrapper"

            style={{
              backgroundImage: `url(${BASE_URL}${bannerData.image})`,
              backgroundSize: 'contain',
              backgroundPosition: 'center',
              height: "50px"
            }}


            data-overlay="title" data-opacity={8}>
            <div className="breadcumb-shape" data-bg-src="/assets/img/bg/breadcumb_shape_1_1.png">
            </div>
            <div className="shape-mockup breadcumb-shape2 jump d-lg-block d-none" data-right="30px" data-bottom="30px">
              <img src="/assets/img/bg/breadcumb_shape_1_2.png" alt="shape" />
            </div>
            <div className="shape-mockup breadcumb-shape3 jump-reverse d-lg-block d-none" data-left="50px" data-bottom="80px">
              <img src="/assets/img/bg/breadcumb_shape_1_3.png" alt="shape" />
            </div>
            <div className="container">
              <div className="breadcumb-content text-center">
                <h1 className="breadcumb-title">Courses Details</h1>
                <ul className="breadcumb-menu">
                  <li><NavLink to="/">Home</NavLink></li>
                  <li>Courses Details</li>
                </ul>
              </div>
            </div>
          </div>
        )}
      {
        singlecourseloading ? (
          <Loader />
        ) : (
          singleCourse.map((curitem, index) => (
            <section className="space-top space-extra2-bottom" key={index} id="target-section" >
              <div className="container">
                <div className="row">
                  <div className="col-xxl-9 col-lg-8">
                    <div className="course-single">
                      <div className="course-single-top">
                        <div className="course-img">
                          <img src={curitem?.Course_img ? `${BASE_URL}${curitem?.Course_img}` : '/assets/img/AA_LOgo_Black.png'} alt="Course Image" />

                          <span className="tag"><i className="fas fa-clock" /> {curitem?.CourseMaster_duration} {curitem?.CourseMaster_duration_unit}</span>
                          <span className="tag bg-theme">BEST SELLER</span>
                        </div>
                        <div className="course-meta style2">
                          <span><i className="fal fa-file" /> Lesson : {curitem?.course_lesson}</span>
                          <span><i className="fal fa-user" /> Students : {curitem.Number_of_students}</span>
                          <span><i className="fal fa-chart-simple" />{curitem.course_level}</span>
                        </div>
                        <h2 className="course-title">{curitem.CourseMaster_title}</h2>
                        <ul className="course-single-meta">
                          {/* <li className="course-single-meta-author">
                <img src={`${BASE_URL}${curitem.CourseMaster_tumbimage}`}  alt="author" />
                <span>
                  <span className="meta-title">Instructor: </span>
                  <NavLink to="/course">{curitem.CourseMaster_Courseinstructor.CourseInstructor_name}</NavLink>
                </span>
              </li> */}
                          <li>
                            <span className="meta-title">Category: </span>
                            <NavLink to="/course">{curitem?.CourseMaster_courseCat.category_name}</NavLink>
                          </li>

                          <li>
                            <span className="meta-title">Last Update: </span>
                            <NavLink to="/course">
                              {new Date(curitem.update_date).toLocaleDateString("en-GB", {
                                day: "2-digit",
                                month: "long",
                                year: "numeric",
                              })}
                            </NavLink>
                          </li>

                          <li>
                            <span className="meta-title">Review: </span>

                            <div className="course-rating">
                              <div
                                className="star-rating"
                                role="img"
                                aria-label={`Rated ${curitem.CourseMaster_rating} out of 5`}
                              >
                                <span style={{ width: `${(curitem.CourseMaster_rating / 5) * 100}%`, }}>
                                  Rated <strong className="rating">{curitem.CourseMaster_rating}</strong> out of 5
                                </span>
                              </div>
                              ({curitem.CourseMaster_rating})
                            </div>
                          </li>

                        </ul>
                      </div>



                      <div className="course-single-bottom ">
                        <ul className="nav course-tab " id="courseTab" role="tablist">
                          <li className="nav-item" role="presentation">
                            <button
                              className={`nav-link ${ActiveTab === 'Coursedescription' ? 'active' : ''}`}
                              id="description-tab"
                              onClick={() => handleTabClick('Coursedescription')}
                              role="tab"
                              aria-controls="Coursedescription"
                              aria-selected={ActiveTab === 'Coursedescription'}
                            >
                              <i className="fa-regular fa-bookmark" /> Overview
                            </button>
                          </li>

                          <li className="nav-item" role="presentation">
                            <button
                              className={`nav-link ${ActiveTab === 'curriculam' ? 'active' : ''}`}
                              id="curriculam-tab"
                              onClick={() => handleTabClick('curriculam')}
                              role="tab"
                              aria-controls="curriculam"
                              aria-selected={ActiveTab === 'curriculam'}
                            >
                              <i className="fa-regular fa-book" /> Curriculam
                            </button>
                          </li>

                          {/* <li className="nav-item" role="presentation">
          <button
            className={`nav-link ${ActiveTab === 'instructor' ? 'active' : ''}`}
            id="instructor-tab"
            onClick={() => handleTabClick('instructor')}
            role="tab"
            aria-controls="instructor"
            aria-selected={ActiveTab === 'instructor'}
          >
            <i className="fa-regular fa-user" /> Instructor
          </button>
        </li> */}

                          <li className="nav-item" role="presentation">
                            <button
                              className={`nav-link ${ActiveTab === 'reviews' ? 'active' : ''}`}
                              id="reviews-tab"
                              onClick={() => handleTabClick('reviews')}
                              role="tab"
                              aria-controls="reviews"
                              aria-selected={ActiveTab === 'reviews'}>
                              <i className="fa-regular fa-star-sharp" /> Reviews
                            </button>
                          </li>

                          {
                            !curitem.is_enroll ? (
                              <>
                                <li className="nav-item" role="presentation">
                                  <button
                                    className={`nav-link ${ActiveTab === 'start_course' ? 'active' : ''}`}
                                    id="start_course-tab"
                                    onClick={() => handleTabClick('start_course')}
                                    role="tab"
                                    aria-controls="reviews"
                                    aria-selected={ActiveTab === 'start_course'}>
                                    <i className="fa-solid fa-graduation-cap" /> start course
                                  </button>
                                </li>
                              </>
                            ) : (
                              <>

                              </>
                            )
                          }
                        </ul>



                        <div className="tab-content" id="productTabContent">
                          {/* Coursedescription */}

                          <div className={`tab-pane fade ${ActiveTab === 'Coursedescription' ? 'show active' : ''}`} id="Coursedescription" role="tabpanel" aria-labelledby="description-tab">
                            <div className="course-description">
                              <h5 className="h5">Description</h5>
                              <div dangerouslySetInnerHTML={{ __html: curitem?.Description }}></div>

                              <h5 className="h5 mt-5">What Will You Learn?</h5>

                              <p dangerouslySetInnerHTML={{ __html: curitem?.courseMaster_detail_id?.Whatyoulearn }}></p>

                              <h5 className="h5 mt-40">Certification</h5>
                              <p dangerouslySetInnerHTML={{ __html: curitem?.courseMaster_detail_id?.Certification }}></p>

                            </div>
                          </div>

                          {/* curriculam */}
                          <div className={`tab-pane fade ${ActiveTab === 'curriculam' ? 'show active' : ''}`} id="curriculam" role="tabpanel" aria-labelledby="curriculam-tab">
                            <div className="course-curriculam">
                              <h5 className="h5">The Course Curriculam</h5>
                              <p className="mb-30" dangerouslySetInnerHTML={{ __html: curitem?.courseMaster_detail_id?.Curriculam }}>
                              </p>
                            </div>
                          </div>

                          {/* instructor */}
                          {/* <div className={`tab-pane fade ${ActiveTab === 'instructor' ? 'show active' : ''}`} id="instructor" role="tabpanel" aria-labelledby="instructor-tab">
                            <Wrapper>
                              <div className="course-instructor">
                                <div className="course-author-box">

                                  <div className="auhtor-img">
                                    <img src={`${BASE_URL}${curitem?.CourseMaster_Courseinstructor?.CourseInstructor_image}`} alt="Author Image"
                                    //  style={{ width: '70%', height: '90%', objectFit: 'cover' }}
                                    />
                                  </div>
                                  <div className="media-body">
                                    <h3 className="author-name"><NavLink to="/team-detail" className="text-inherit">{curitem.CourseMaster_Courseinstructor?.CourseInstructor_name}</NavLink></h3>
                                    <p className="author-text">{curitem?.CourseMaster_Courseinstructor?.CourseInstructor_shortbio}</p>

                                    <div className="author-meta">

                                      <NavLink to="/course"><i className="fal fa-file-video" />4 Courses</NavLink>

                                      <span><i className="fal fa-users" />2500 Students</span>
                                    </div>

                                    <div className="th-social">
                                      <a href="https://facebook.com/" target="_blank"><i className="fab fa-facebook-f" /></a>
                                      <a href="https://twitter.com/" target="_blank"><i className="fab fa-twitter" /></a>
                                      <a href="https://linkedin.com/" target="_blank"><i className="fab fa-linkedin-in" /></a>
                                      <a href="https://instagram.com/" target="_blank"><i className="fab fa-instagram" /></a>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </Wrapper>
                          </div> */}
                          {/* Reviews */}

                          <div className={`tab-pane fade ${ActiveTab === 'reviews' ? 'show active' : ''}`} id="reviews" role="tabpanel" aria-labelledby="reviews-tab">
                            <Course_Reviwe courseid={curitem.id} />
                          </div>


                          <div className={`tab-pane fade ${ActiveTab === 'start_course' ? 'show active' : ''}`} id="start_course" role="tabpanel" aria-labelledby="start_course-tab">
                            {/* <Course_Reviwe courseid={curitem.id} /> */}
                            <Startr_course />
                          </div>


                        </div>
                      </div>
                    </div>
                  </div>
                  {/* Course Information */}
                  <div className="col-xxl-3 col-lg-4">
                    <aside className="sidebar-area">
                      <div className="widget widget_info  ">
                        <div className="th-video">
                          {/* <img src= {`${BASE_URL}${curitem.Video_img}`} alt="video" /> */}
                       
      {
   curitem.Video_img ? (
    <video
      src={`${BASE_URL}${curitem.Video_img}`}
      controls
      autoPlay
      muted
      loop
      style={{ width: "100%", height: "auto" }}
    >
      Your browser does not support the video tag.
    </video>
  ) : (
    <img
      src="/assets/img/AA_LOgo_Black.png"
      alt={curitem?.titile}
      style={{ width: "100%", height: "auto" }}
    />
  )
}




                          <NavLink to="/" className="play-btn popup-video"><i className="fas fa-play" /></NavLink>
                        </div>
                        <span className="h4 course-price">
                          {curitem.CourseMaster_fee > 0 ? (
                            <>
                              <Formatprice price={curitem.CourseMaster_fee} />
                              {/* <span className="tag">25% Off</span> */}
                            </>
                          ) : (
                            "Free"
                          )}
                        </span>
                        <div>
                          <button className="th-btn style4" onClick={() => handleAddToCartClick(curitem.id)}>
                            {isLoggedIn ?  ( <>
                            <i className="fa-solid fa-cart-plus" /> Add To Cart  </>) : "Enroll Now"}<i className="fas fa-arrow-right ms-2" />
                          </button>

                          {
                            curitem?.is_enroll && (
                              <Link to={`/courses/${curitem?.slug}`}>
                                <button className="th-btn style4">
                                  <i className="fa-solid fa-graduation-cap" /> Start Courses
                                  <i className="fas fa-arrow-right ms-2" />
                                </button>
                              </Link>
                            )
                          }


                          {/* Modal for login/sign-in */}

                          <Modal show={show} onHide={handleClose} centered size='xl'>
                            <Modal.Header closeButton />
                            <Modal.Body>
                              {isSignin ? (
                                <Signin setIsSignin={setIsSignin} />
                              ) : (
                                <Login handleClose={handleClose} />
                              )}
                            </Modal.Body>
                            <Modal.Footer>


                              <div className="btn-group">
                                <Button className="th-btn style3" onClick={toggleForm}>
                                  {isSignin ? "Switch to Log In" : "Switch to Sign Up"}<i className="fas fa-arrow-right ms-2" />
                                </Button>
                              </div>
                              <div className="btn-group">
                                <Button className="th-btn style3 bg-danger border-danger" onClick={handleClose}>
                                  Close<i className="fas fa-arrow-right ms-2" />
                                </Button>
                              </div>

                            </Modal.Footer>
                          </Modal>

                        </div>



                        {/* <NavLink to="/cartpage"className="th-btn style4">Buy Now</NavLink> */}


                        <h3 className="widget_title">Course Information</h3>
                        <div className="info-list">
                          <ul>
                            {/* <li>
                  <i className="fa-light fa-user" />
                  <strong>Instructor: </strong>
                  <span>{curitem.CourseMaster_Courseinstructor.CourseInstructor_name}</span>
                </li> */}
                            <li>
                              <i className="fa-light fa-users" />
                              <strong>&nbsp;Students :</strong>
                              <span>{curitem.Number_of_students}</span>
                            </li>

                            <li>
                              <i className="fa-light fa-file" />
                              <strong>Lessons: </strong>
                              <span>{curitem.course_lesson}</span>
                            </li>
                            <li>
                              <i className="fa-light fa-clock" />
                              <strong>Duration: </strong>
                              <span>{curitem.CourseMaster_duration} {curitem.CourseMaster_duration_unit}</span>
                            </li>
                            <li>
                              <i className="fa-light fa-tag" />
                              <strong>Course level: </strong>
                              <span>{curitem.course_level}</span>
                            </li>
                            <li>
                              <i className="fa-light fa-globe" />
                              <strong>Language: </strong>
                              <span>{curitem.Language}</span>
                            </li>
                            <li>
                              <i className="fa-light fa-puzzle-piece" />
                              <strong>Quizzes: </strong>
                              <span>{curitem.Quizzes}</span>
                            </li>
                          </ul>
                        </div>

                        {/* <a href="https://www.linkedin.com/" className="th-btn style6 mt-35 mb-0"><i className="far fa-share-nodes me-2" />Share This Course</a> */}
                        <div>
                          <a className="th-btn style6 mt-35 mb-0" onClick={handleShareClick}>
                            <i className="far fa-share-nodes me-2" />
                            Share This Course
                          </a>

                          {showOptions && (
                            <div className="share-options">
                              <ul style={{ display: "flex", justifyContent: "space-between", gap: "20px" }}>
                                <li>
                                  <a
                                    href={`https://wa.me/?text=${encodeURIComponent(window.location.href)}`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                  >
                                    <FaWhatsapp className='whatsapp' style={{ color: "green", fontSize: "2rem" }} />
                                  </a>
                                </li>
                                <li>
                                  <a
                                    href={`https://www.instagram.com$/url=${encodeURIComponent(window.location.href)}`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                  >
                                    <FaInstagram className="insta" style={{ color: '#E1306C', fontSize: '2rem' }} />
                                  </a>
                                </li>
                                <li>
                                  <a
                                    href={`https://www.linkedin.com/url=${encodeURIComponent(window.location.href)}`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                  >
                                    <FaLinkedinIn className='linkedin' style={{ color: '#fff', background: '#0077B5', fontSize: '1.7rem', padding: "2px" }} />
                                  </a>
                                </li>
                                <li>
                                  <button onClick={handleCopy} className='copy'><FaCopy style={{ fontSize: "1.6rem" }} /></button>
                                </li>
                              </ul>
                            </div>

                          )}
                          <style>{`
        .share-options {
          margin-top: 5px;
          background: #fff;
          padding: 10px;
          // border: 1px solid #ddd;
          border-radius: 5px; 
        }
        .share-options ul {
          list-style: none;
          padding: 0;
          margin: 0;
        }
        .share-options ul li {
          margin: 8px 0;
          
        }

        .share-options ul li a,
        .share-options ul li button {
          text-decoration: none;
          color: #007bff;
          font-size: 16px;
        }

        .share-options ul li button {
          background: none;
          border: none;
          cursor: pointer;
        }
      `}</style>

                        </div>

                      </div>
                    </aside>
                  </div>

                </div>
              </div>
            </section>
          )))}

      <Service />

    </>
  )
}

const Wrapper = Styled.section`
  .course-author-box {
  display: flex;
  justify-content: space-between; /* Space between the children */
  align-items: center; /* Center align the items vertically */
  gap: 20px; /* Space between the child divs */
  padding: 20px;
  background-color: #f9f9f9; /* Optional background color */
  border-radius: 10px; /* Rounded corners */
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1); /* Subtle shadow for styling */
}

/* Left Div: Image Container */
.auhtor-img {
  flex: 1; /* Take equal space as media-body */
  display: flex;
  justify-content: center; /* Center the image horizontally */
  align-items: center; /* Center the image vertically */
}

.auhtor-img img {
  width: 100%; /* Full width of the container */
  max-width: 300px; /* Maximum width for the image */
  height: auto; /* Maintain aspect ratio */
  border-radius: 3%;
  /* object-fit: cover;  */
  border: 1px solid #ddd; 
}

/* Right Div: Text and Meta Info */
.media-body {
  flex: 1; /* Take equal space as auhtor-img */
  display: flex;
  flex-direction: column; /* Stack items vertically */
  gap: 10px; /* Space between elements */
}

/* Author Name */
.author-name {
  font-size: 1.2rem;
  font-weight: bold;
  margin: 0;
}

.author-name a {
  text-decoration: none;
  color: #333;
  transition: color 0.3s ease;
}

.author-name a:hover {
  color: #007bff;
}

/* Author Bio */
.author-text {
  font-size: 0.9rem;
  color: #555;
  line-height: 1.5;
  margin: 0;
}

/* Author Meta Information */
.author-meta {
  display: flex;
  gap: 20px; /* Space between items */
  font-size: 0.9rem;
  color: #666;
}

.author-meta a {
  text-decoration: none;
  color: inherit;
  transition: color 0.3s ease;
}

.author-meta a:hover {
  color: #007bff;
}

/* Social Links */
.th-social {
  display: flex;
  gap: 10px;
}

.th-social a {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  background-color: #007bff;
  color: #fff;
  border-radius: 50%;
  font-size: 1rem;
  text-decoration: none;
  transition: background-color 0.3s ease, transform 0.2s ease;
}

.th-social a:hover {
  background-color: #0056b3;
  transform: scale(1.1);
}

/* Responsive Design */
@media (max-width: 768px) {
  .course-author-box {
    flex-direction: column; /* Stack child divs vertically */
    align-items: center;
  }

  .auhtor-img {
    margin-bottom: 10px;
  }

  .media-body {
    text-align: center;
  }
}
`


const Striky = styled.section`
.sticky-course-tab {
  position: sticky;
  top: 80px; /* Adjust based on your navbar/header height */
  z-index: 100;
  background: #fff; /* Needed so content under it isn't visible */
  padding-top: 10px;
}


`
export default Coursedetail